// extracted by mini-css-extract-plugin
export default {"container":"supportDoc_container__X2Ku2","content":"supportDoc_content__PViGG"};